/**
 * Minimal YAML-like frontmatter loader for static markdown files under
 * /public/content/findings/<id>.md.
 *
 * To add a new finding:
 *   1. Drop a new <id>.md file into /public/content/findings/.
 *   2. Add the id to /public/content/findings/index.json (in display order).
 *
 * Frontmatter fields used: id, title, date, tag, summary, chart, bibtex
 */

const INDEX_URL = "/content/findings/index.json";
const fileUrl = (id) => `/content/findings/${id}.md`;

function parseFrontmatter(raw) {
  const m = raw.match(/^---\s*\n([\s\S]*?)\n---\s*\n?([\s\S]*)$/);
  if (!m) return { meta: {}, body: raw.trim() };
  const yaml = m[1];
  const body = m[2].trim();
  const meta = {};

  const lines = yaml.split(/\r?\n/);
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    const kv = line.match(/^([a-zA-Z_][a-zA-Z0-9_-]*)\s*:\s*(.*)$/);
    if (!kv) {
      i++;
      continue;
    }
    const key = kv[1];
    const val = kv[2];

    if (val.trim() === "|") {
      // block-literal scalar, indented lines follow
      i++;
      const block = [];
      while (i < lines.length && /^\s{2,}/.test(lines[i])) {
        block.push(lines[i].replace(/^\s{2}/, ""));
        i++;
      }
      meta[key] = block.join("\n").trimEnd();
      continue;
    }
    meta[key] = val.trim();
    i++;
  }
  return { meta, body };
}

let _cache = null;

export async function loadFindings() {
  if (_cache) return _cache;
  const idx = await fetch(INDEX_URL, { cache: "no-cache" }).then((r) =>
    r.json(),
  );
  const posts = await Promise.all(
    idx.order.map(async (id) => {
      const raw = await fetch(fileUrl(id), { cache: "no-cache" }).then((r) =>
        r.text(),
      );
      const { meta, body } = parseFrontmatter(raw);
      return { ...meta, id: meta.id || id, body };
    }),
  );
  _cache = posts;
  return posts;
}
